import React from "react"
import ReactDOM  from "react-dom/client"
import App from './app'
import "./index.css"
import "./app.css"

ReactDOM.createRoot(document.getElementById("root")).render(<App />)